module.exports = __webpack_public_path__ + "img/checklist-button-balls.8bcc85b9.png";